var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-identity"},[_c('span',{staticClass:"file-type-icon",class:_vm.kind},[_c('i',{class:_vm.icon})]),_c('span',{staticClass:"file-identity-text"},[_c('strong',{attrs:{"title":_vm.name}},[_vm._v(_vm._s(_vm.name))]),_c('small',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }